import { render, staticRenderFns } from "./PeriodDays.vue?vue&type=template&id=20d0b340&scoped=true"
import script from "./PeriodDays.vue?vue&type=script&lang=js"
export * from "./PeriodDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0b340",
  null
  
)

export default component.exports